import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  filterChanged(event) {
    const checkbox = event.target
    const url = new URL(window.location.href)

    if (checkbox.checked) {
      url.searchParams.set("filter_named_only", "true")
    } else {
      url.searchParams.set("filter_named_only", "false")
    }

    window.location.href = url.toString()
  }
}

